import { IconPrefix } from '@fortawesome/fontawesome-svg-core'

const faIconStyle: IconPrefix = 'fas'

export default { faIconStyle }
